module.exports = __webpack_public_path__ + "static/media/beach.2e59e7e6.svg";